import React from "react";
import { useTranslation } from "react-i18next";
import { normalizePaymentStatus } from "../utils/patientAccountUtils";

const STATUS_CONFIG = {
	paid: { className: "badge bg-primary", label: "Paid" },
	partial_paid: { className: "badge patient-accounts-status-partial", label: "Partially Paid" },
	unpaid: { className: "badge patient-accounts-status-unpaid", label: "Unpaid" },
};

const InvoiceStatusBadge = ({ status, isSettled = false }) => {
	const { t } = useTranslation();
	const normalized = normalizePaymentStatus(status);
	const config = STATUS_CONFIG[normalized] || STATUS_CONFIG.unpaid;

	return (
		<span className="d-inline-flex flex-wrap gap-1 align-items-center">
			<span className={config.className} style={{ textTransform: "capitalize" }}>
				{t(config.label)}
			</span>
			{isSettled && (
				<span className="badge patient-accounts-status-settled">{t("Settled")}</span>
			)}
		</span>
	);
};

export default InvoiceStatusBadge;
